import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'compact-history-button',
  templateUrl: './history-button.component.html',
  styleUrls: ['./history-button.component.less'],
  standalone: false
})
export class HistoryButtonComponent {
  @Input() item: any;
  @Input() showCondition: boolean = true;
  @Input() tooltip: string = '';
  @Input() buttonText: string = 'Get History';
  @Input() disabled: boolean = false;

  @Output() historyClick = new EventEmitter<any>();

  onHistoryClick(): void {
    if (!this.disabled && this.item) {
      this.historyClick.emit(this.item);
    }
  }
} 